import React from "react"
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Paper,
  Divider,
} from "@mui/material"

import { Row, Col } from "react-bootstrap"

import PublicIcon from "@mui/icons-material/Public"
import SupportAgentIcon from "@mui/icons-material/SupportAgent"
import { motion } from "framer-motion"

import ContactForm from "../ContactForm"
import CallToAction from "../CallToAction"
import BlogsSection from "../Blogs/BlogsSection" 

const stats = [
  { label: "Clients", value: "2,345" },
  { label: "Staff Members", value: "345" },
  { label: "Services Offered", value: "120+" },
  { label: "Countries Served", value: "14+" },
]

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
}

const ServiceNotFound = () => {
  return (
    <Box>
      <Box component="section" py={8} bgcolor={'white'}>
        <Container maxWidth="lg">
          <Row container spacing={6}>
            <Col item xs={12} md={7}>
              <motion.div initial="hidden" animate="visible" variants={fadeUp}>
                <Typography variant="h4" fontWeight={600} gutterBottom>
                  Get a Free Quote Calculation
                </Typography>
                <Typography variant="body1" color="text.secondary" mb={4}>
                  For a quick calculation of your expenses, send us your info. Our accounting experts will build the best possible offer.
                </Typography>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <PublicIcon color="primary" sx={{ fontSize: 48 }} />
                    <Typography variant="h6" fontWeight={600} mt={2}>
                      International Accounting
                    </Typography>
                    <Typography color="text.secondary">
                      Operating in over 14 countries with 200+ employees worldwide.
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <SupportAgentIcon color="primary" sx={{ fontSize: 48 }} />
                    <Typography variant="h6" fontWeight={600} mt={2}>
                      24/7 Availability
                    </Typography>
                    <Typography color="text.secondary">
                      Always available with fast response and delivery times.
                    </Typography>
                  </Grid>
                </Grid>
              </motion.div>
            </Col>

            <Col item xs={12} md={5}>
              <motion.div whileHover={{ scale: 1.02 }} style={{ padding: 32, border: "1px solid #eee", backgroundColor: "#fff", borderRadius: 8 }}>
                <ContactForm />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </Box>

      <motion.section initial="hidden" whileInView="visible" variants={fadeUp} viewport={{ once: true }}>
        <BlogsSection></BlogsSection>
      </motion.section>

      {/* FINAL CTA */}
      <CallToAction></CallToAction>
    </Box>
  )
}

export default ServiceNotFound
